import { Injectable } from '@angular/core';
import { StorageEntry, LogEntry, SaleEntry } from "./ledger-entry";

import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
declare var M: any;
@Injectable({
  providedIn: 'root'
})
export class StorageService {

  Log: AngularFirestoreCollection<LogEntry>;
  private LogDoc: AngularFirestoreDocument<LogEntry>;
  log: Observable<any[]>;

  Sale: AngularFirestoreCollection<SaleEntry>;
  private SaleDoc: AngularFirestoreDocument<SaleEntry>;
  sale: Observable<any[]>;

  Storage: AngularFirestoreCollection<StorageEntry>;
  private StorageDoc: AngularFirestoreDocument<StorageEntry>;
  storage: Observable<any[]>;

  userProfile: any;
  user: any;

  constructor(public authService: AuthService, private db: AngularFirestore) {
    //Get the tasks collection
    this.Storage = db.collection<StorageEntry>("generalStorage");
    this.Log = db.collection<LogEntry>("generalLog");
    this.Sale = db.collection<SaleEntry>("generalSale");
  }
  getStorage() {
  //  console.log("storage");
    this.db.collection<StorageEntry>("generalStorage").get().pipe(map((querySnapshot) => {
    //  console.log(querySnapshot);
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
      //  console.log(doc.id, " => ", doc.data());
      });
    }));
  }
  addStorageTask(StorageEntry) {
    //Add the new task to the collection
    this.Storage.add(StorageEntry).then(doc => {
      let s = JSON.parse(JSON.stringify(StorageEntry));
      StorageEntry.date = new Date();
      StorageEntry.id = doc.id;
      StorageEntry.new = 0;
      StorageEntry.return = 0;
      StorageEntry.sale = 0;
      StorageEntry.type = "new";
      delete StorageEntry.log;
      delete StorageEntry.logs;
      this.addLogTask(StorageEntry, s);
      M.toast({ html: 'Storage entry added!' })
    }).catch((error) => {
      M.toast({ html: error })
    });

    //this.Log.add(StorageEntry);
  } //addTask
  updateStorageTask(id, update, editType, old) {
    this.StorageDoc = this.db.doc<StorageEntry>(`${"generalStorage"}/${id}`);
    //Get the task document
    switch (editType) {
      case "update":
        // //! delete to save memory
        // let newLogs = [];
        // let date = new Date();
        // let newUpdate = JSON.parse(JSON.stringify(update));
        // delete newUpdate.log;
        // delete newUpdate.logs;
        // update.logs.forEach(element => {
        //   element["update " + date] = newUpdate;
        //   newLogs.push(newUpdate);
        // });
        // update.logs = newLogs;
        // //!
        this.StorageDoc.update(update).then(any => {
          M.toast({ html: 'Storage entry updated successfully!' })

        }).catch((error) => {
          M.toast({ html: error })
        });
        // let me = this;

        // update.log.forEach(element => {
        //   me.updateLogTask(element, update);
        // });
        break;
      case "edit":
        // //! delete to save memory
        // let newLogs = [];
        // let date = new Date();
        // let newUpdate = JSON.parse(JSON.stringify(update));
        // delete newUpdate.log;
        // delete newUpdate.logs;
        // update.logs.forEach(element => {
        //   element["update " + date] = newUpdate;
        //   newLogs.push(newUpdate);
        // });
        // update.logs = newLogs;
        // //!
        this.StorageDoc.update(update).then(any => {
          M.toast({ html: 'Storage entry updated successfully!' })

        }).catch((error) => {
          M.toast({ html: error })
        });
        let me = this;

        update.log.forEach(element => {
          me.updateLogTask(element, update);
        });
        break;
      case "sale":
        
        old.quantity -= update.quantity;
        let buyer = old.buyer
        delete old.buyer;
        this.StorageDoc.update(old).then(any => {
          M.toast({ html: 'Storage entry updated successfully!' })

        }).catch((error) => {
          M.toast({ html: error })
        });
        let s = JSON.parse(JSON.stringify(old));
        old.date = new Date();
        old.id = id;
        old.new = 0;
        old.return = 0;
        old.sale = update.quantity;
        old.type = editType;
        old.retailPrice = update.retailPrice;
        old.buyer = buyer;
        delete old.log;
        delete old.logs;
        this.addLogTask(old, s);
        break;
      case "return":
        old.quantity += update.quantity;
        this.StorageDoc.update(old).then(any => {
          M.toast({ html: 'Storage entry updated successfully!' })

        }).catch((error) => {
          M.toast({ html: error })
        });
        let ss = JSON.parse(JSON.stringify(old));
        old.date = new Date();
        old.id = id;
        old.new = 0;
        old.return = update.quantity;
        old.sale = 0;
        old.type = editType;
        delete old.log;
        delete old.logs;
        this.addLogTask(old, ss);
        break;
      case "new":
        old.quantity += update.quantity;
        old.shipmentNumber = update.shipmentNumber;
        this.StorageDoc.update(old).then(any => {
          M.toast({ html: 'Storage entry updated successfully!' })

        }).catch((error) => {
          M.toast({ html: error })
        });
        let sss = JSON.parse(JSON.stringify(old));
        old.date = new Date();
        old.id = id;
        old.new = update.quantity;
        old.return = 0;
        old.sale = 0;
        old.type = editType;
        delete old.log;
        delete old.logs;
        this.addLogTask(old, sss);
        break;
      default:
        // code block
        break
    }
    
  } 
  //updateTask
  deleteStorageTask(id, logs) {
    // delete all task logs
    //Get the task document
    this.StorageDoc = this.db.doc<StorageEntry>(`${"generalStorage"}/${id}`);
    //Delete the document
    this.StorageDoc.delete().then(() => { M.toast({ html: 'Storage entry deleted!' })});
    let me = this;
  //  console.log(logs);

    logs.forEach(element => {
    //  console.log(element);
      me.deleteLogTask(element);
    });
    
  }


  getLog() {
    //  console.log("log");
    this.db.collection<LogEntry>("generalLog").get().pipe(map((querySnapshot) => {
      //  console.log(querySnapshot);
      querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      //  console.log(doc.id, " => ", doc.data());
      });
    }));
  }
  //
  addLogTask(LogEntry: LogEntry, s) {
    //Add the new task to the collection
    let me = this;
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    LogEntry.user = this.userProfile.displayName;
    LogEntry.userId = this.user.uid;
    this.Log.add(LogEntry).then(doc => {
      s.log.push(doc.id);
      s.logs.push(LogEntry);//!delete for memory save
      delete s.id;
      delete s.userId;
      delete s.user;

      me.updateStorageTask(LogEntry.id, s, 'update', null);
      //? set to edit for update operation however revise update log function
    });
    
  } //addTask
  updateLogTask(id, update) {
    //Get the task document
    let me = this;
    delete update.log;
    delete update.logs;
    //var value = data[key];
    me.LogDoc = me.db.doc<LogEntry>(`${"generalLog"}/${id}`);
    // me.LogDoc.get().pipe(map((querySnapshot) => {
    // //  console.log(querySnapshot);
    //   Object.keys(update).forEach(function (key) {
    //     querySnapshot[key] = update[key];
    //   });
    //   me.LogDoc.update(querySnapshot);
    // }));
    let u = {};
    let date = new Date();
    delete update.quantity;
    delete update.shipmentNumber;
    me.LogDoc.update(update);
  } //updateTask
  deleteLogTask(id) {
    //Get the task document
    this.LogDoc = this.db.doc<LogEntry>(`${"generalLog"}/${id}`);
    //Delete the document
    this.LogDoc.delete();
  }
  getSale() {
  //  console.log("Sale");
    this.db.collection<SaleEntry>("generalSale").get().pipe(map((querySnapshot) => {
    //  console.log(querySnapshot);
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
      //  console.log(doc.id, " => ", doc.data());
      });
    }));
  }
  addSale(SaleEntry: SaleEntry) {
    //Add the new Sale to the collection
    this.Sale.add(SaleEntry).then((s) => {
      M.toast({ html: 'Sale order created!' })

    });
  }
  //addSale
  updateSale(id, update) {
    //Get the Sale document
    this.SaleDoc = this.db.doc<SaleEntry>(`${"generalSale"}/${id}`);
    delete update.date;
    this.SaleDoc.update(update).then(any => { 
      M.toast({ html: 'sale order updated!' })
      
    });
  } //updateSale
  deleteSale(id) {
    //Get the Sale document
    this.SaleDoc = this.db.doc<SaleEntry>(`${"generalSale"}/${id}`);
    //Delete the document
    this.SaleDoc.delete().then(any => {
      M.toast({ html: 'Sale order deleted!' })

    });
  } //deleteSale
}
